import Link from "next/link";
import { useTranslations } from "next-intl";
import { CookieConsentConfig } from "@/lib/nexus-app";
import { RichTextOrFallback } from "./RichTextOrFallback";
import { BANNER_LINK_CLASS } from "./utils/cookie-consent.utils";

export function CookieConsentBanner({
  content,
  t,
  onManage,
  onAcceptAll,
}: {
  content: CookieConsentConfig | null | undefined;
  t: ReturnType<typeof useTranslations<"CookieConsent">>;
  onManage: () => void;
  onAcceptAll: () => void;
}) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-[99999] px-3 pb-3 sm:px-6 sm:pb-5">
      <div className="mx-auto w-full max-w-7xl rounded-2xl border border-gray-3 bg-white shadow-3">
        <div className="flex flex-col gap-4 p-4 sm:p-6 lg:flex-row lg:items-end lg:justify-between">
          <p className="text-sm leading-6 text-dark-2">
            <RichTextOrFallback
              value={content?.bannerDescription}
              fallback={t.rich("bannerDescription", {
                privacyLink: (chunks) => (
                  <Link href="/privacy-policy" className={BANNER_LINK_CLASS}>
                    {chunks}
                  </Link>
                ),
                googleLink: (chunks) => (
                  <Link
                    href="https://policies.google.com/technologies/partner-sites"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={BANNER_LINK_CLASS}
                  >
                    {chunks}
                  </Link>
                ),
              })}
              linkClassName={BANNER_LINK_CLASS}
            />
          </p>
          <div className="flex flex-col gap-2 sm:flex-row lg:shrink-0">
            <button
              type="button"
              onClick={onManage}
              className="rounded-lg border border-gray-4 px-4 py-2.5 text-sm font-medium text-dark transition-colors hover:bg-gray-1"
            >
              {content?.manageSettingsLabel || t("manageSettings")}
            </button>
            <button
              type="button"
              onClick={onAcceptAll}
              className="rounded-lg bg-blue px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-dark"
            >
              {content?.acceptAllLabel || t("acceptAll")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
